export default{
    mensHealth: "Men's Health",
    womensHealth: "Women's Health",
    fertility: 'Fertility',
    infertility: 'Infertility',
    legal: 'legal',
    egg_freezer_for_single: 'Egg Freezer For Single',
    psychological_advisor: 'Psychological Advisor',
    egg_freezer_for_married: 'Egg Freezer For Married',
    married_donor: 'Married Donor',
    divorced_donor: 'Divorced Donor',
    radiology: 'Radiology',
    glands: 'Glands',
    service: 'Service',
    doctor: 'Doctor',
    patient: 'Patient',
    discountGroupId: 'Discount Group',
    presence: 'Presence',
    call: 'Call',
    endOfPresence: 'End Of Presence',
    receptionDone: 'Reception Done',
    triageDone: 'Triage Done',
    noCharge: 'No Charge',
    repeat: 'Repeat',
    description: 'Description',
    createdAt: 'Date',
    total: 'Total',
    discount: 'Discount',
    pay:'Pay',
    addExcessPayment:'Excess Payment',
    excessRequestAndSubmission:'Excess Request And Submission',
    amount: 'Amount',
    paymentType: 'PaymentType',
    pos: 'Pos',
    room: 'Room',
    addService: 'Add Service',
    postReferrals: 'Post Referrals',
    firstName: 'First Name',
    patientsName: "Patient's Name",
    startAndEndOfPresence:"Start And End Of Doctor's Presence",
    pastPayments: 'Past Payments',
    tabs:{addService: 'Add A Service', medicalRecords:'Medical Records', postReferrals: 'Post Referrals'},
    bankCard: 'Bank Cards',
    sendToQueue: 'Send To Queue',
    callingNumber: 'Recall Number',
    excessRequest: 'excessRequest',
    returnDescription: 'Return Description',
    medicalRecords:{
        infertility: 'Infertility',
        gynecology: 'Gynecology',
        obstetric: 'Obstetric',
        glands: 'Glands',
        genetics: 'Genetics',
        nourish: 'Nourish',
        urology: 'Urology',
        legal: 'Legal',
        lab: 'Lab',

    },
    serviceReturn: 'Service Return',
    returnSubmission: 'Submit Return',
    select: 'Select',
    status: 'Status',
    currentServiceReturns: 'Current Service Returns',
    returnStatuses:{
        requestReturn: 'In Progress',
        confirmReturn: 'Confirmed',
        withoutServiceAndPayment: 'Without Service And Payment',
        completeDiscount: 'Complete Discount'
    },
    accountingStatuses:{
        debtor: 'Debtor',
        checkout: 'Checkout',
    },
    receptionPaymentDone:"Reception Payment Done",
    printFactor: 'Print Factor',
    printAgain: 'Print Again',
    legacy: 'Upload Legacy Medical Record',
    doneAccounting: 'Done Accounting',
    areYouSureOfDeletion: "Are you sure of ${item}'s referral deletion?",
    currentDayReception:{
        doctor: 'Doctor',
        fullName: 'Full name',
        nationalCode: 'National code',
        insurance: 'Insurance',
        createdUser: 'Created User',
        date:'Date',
        completeReferral: 'Complete Referral',
        currentDayReceptionStatus: 'Current Day Reception Status'
    },
    receptionStatuses:{
        inRoom:'In Room',
        triage:'In Room (Triage)',
        doneTriage:'In Room (Triage Done)',
        preWaiting:'Pre Waiting',
        waiting:'Waiting',
    },
    backToQueue: 'Back To Queue'

}